<div class="d-flex flex-column">
	<div class="d-flex">
		<div class="display-10">How do you want it?</div>
		<div class="ms-auto">
			<span class="link-text" (click)="editMode = true">Change</span>
		</div>
	</div>
	<div class="display-11">
		{{ orderService.activeOrder.value.orderType }}
	</div>
</div>
